import React from 'react'
import { AppRouter } from './routes/AppRouter'

const PortfolioApp = () => {
  return (
    <AppRouter/>
  )
}

export default PortfolioApp;